import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { Button, Form, Checkbox, message, Space } from 'antd';
import NoLoginFooter from 'components/public-components/no-login-footer';
import userStore from 'store/user';
import { useObserver } from 'mobx-react';
import accountManage from '@/store/account-manage';
import { IConfirmContract } from '@/interfaces/user';
import { AxiosError } from 'axios';
import { EFirstStatus } from 'interfaces/account-manage';
import { useModuleTranslation } from '@/i18n/translation';

const WelcomeWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .card {
    background: #ffffff;
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);
    border-radius: 8px;
    padding: 35px;
    max-width: 350px;
    .welcome {
      &-heading {
        padding-bottom: 1.5rem;
      }

      &-message {
        padding-bottom: 1rem;
      }

      &-contract {
        padding-bottom: 2rem;
      }
    }
  }
`;

type IProps = RouteComponentProps<any>;

const Welcome = (props: IProps) => {
  const [isChecked, setIsChecked] = React.useState<boolean>(true);
  const [form] = Form.useForm();
  const { Item } = Form;
  const t = useModuleTranslation('welcome');
  const onClickHandler = async () => {
    try {
      props.history.push('/main/update-password');
    } catch (error) {
      const e = error as AxiosError;
      e.message && message.error(e.message);
    }
  };

  const onClickOk = async () => {
    try {
      const formData = (await form.validateFields()) as IConfirmContract;
      await userStore.confirmContract(formData);
      const userProfile = Object.assign({}, userStore.userProfile, { isFirstLogin: false });
      userStore.setUserProfile(userProfile);
      props.history.push('/main/dashboard');
    } catch (error) {
      const e = error as AxiosError;
      e.message && message.error(e.message);
    }
  };

  return useObserver(() => (
    <WelcomeWrapper>
      <div className="card">
        <div className="welcome-heading">{t.welcome}</div>
        <div className="welcome-message">{accountManage.userInfo?.isCreated ? t.needToAgree : t.needToChange}</div>
        {[EFirstStatus.CONTRACT_PASSWORD, EFirstStatus.CONTRACT].includes(accountManage.userInfo!.firstStatus) && (
          <div className="welcome-contract">
            <Checkbox checked={isChecked} onChange={() => setIsChecked(!isChecked)}>
              {t.agree}{' '}
              <a href={userStore.userProfile.contract} target="_blank" rel="noopener noreferrer">
                {t.contract}
              </a>
            </Checkbox>
          </div>
        )}
        {accountManage.userInfo?.isCreated ? (
          <Button type="primary" onClick={onClickOk} disabled={!isChecked}>
            {t.ok}
          </Button>
        ) : (
          <Button type="primary" onClick={onClickHandler} disabled={!isChecked}>
            {t.change}
          </Button>
        )}
      </div>
      <NoLoginFooter />
    </WelcomeWrapper>
  ));
};
export default withRouter(Welcome);
